// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/keys/v1/keys.proto (package penumbra.core.keys.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * A Penumbra address. An address in Penumbra is a Bech32m-encoded
 * string, with the human-readable prefix (HRP) `penumbrav2t`.
 *
 * @generated from message penumbra.core.keys.v1.Address
 */
export class Address extends Message {
    /**
     * The bytes of the address. Must be represented as a series of
     * `uint8` (i.e. values 0 through 255), with a length of 80 elements.
     *
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    /**
     * Alternatively, a Bech32m-encoded string representation of the `inner`
     * bytes.
     *
     * NOTE: implementations are not required to support parsing this field.
     * Implementations should prefer to encode the bytes in all messages they
     * produce. Implementations must not accept messages with both `inner` and
     * `alt_bech32m` set.
     *
     * @generated from field: string alt_bech32m = 2;
     */
    altBech32m = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.Address";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "alt_bech32m", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Address().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Address().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Address().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Address, a, b);
    }
}
/**
 * @generated from message penumbra.core.keys.v1.AddressView
 */
export class AddressView extends Message {
    /**
     * @generated from oneof penumbra.core.keys.v1.AddressView.address_view
     */
    addressView = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.AddressView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "decoded", kind: "message", T: AddressView_Decoded, oneof: "address_view" },
        { no: 2, name: "opaque", kind: "message", T: AddressView_Opaque, oneof: "address_view" },
    ]);
    static fromBinary(bytes, options) {
        return new AddressView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddressView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddressView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddressView, a, b);
    }
}
/**
 * A decoded address, with information about the address index and wallet ID visible.
 *
 * @generated from message penumbra.core.keys.v1.AddressView.Decoded
 */
export class AddressView_Decoded extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.Address address = 1;
     */
    address;
    /**
     * @generated from field: penumbra.core.keys.v1.AddressIndex index = 2;
     */
    index;
    /**
     * @generated from field: penumbra.core.keys.v1.WalletId wallet_id = 3;
     */
    walletId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.AddressView.Decoded";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address", kind: "message", T: Address },
        { no: 2, name: "index", kind: "message", T: AddressIndex },
        { no: 3, name: "wallet_id", kind: "message", T: WalletId },
    ]);
    static fromBinary(bytes, options) {
        return new AddressView_Decoded().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddressView_Decoded().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddressView_Decoded().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddressView_Decoded, a, b);
    }
}
/**
 * An opaque address, with no information about the address index or wallet ID visible.
 *
 * @generated from message penumbra.core.keys.v1.AddressView.Opaque
 */
export class AddressView_Opaque extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.Address address = 1;
     */
    address;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.AddressView.Opaque";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address", kind: "message", T: Address },
    ]);
    static fromBinary(bytes, options) {
        return new AddressView_Opaque().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddressView_Opaque().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddressView_Opaque().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddressView_Opaque, a, b);
    }
}
/**
 * @generated from message penumbra.core.keys.v1.PayloadKey
 */
export class PayloadKey extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.PayloadKey";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new PayloadKey().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PayloadKey().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PayloadKey().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PayloadKey, a, b);
    }
}
/**
 * @generated from message penumbra.core.keys.v1.SpendKey
 */
export class SpendKey extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.SpendKey";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new SpendKey().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpendKey().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpendKey().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpendKey, a, b);
    }
}
/**
 * @generated from message penumbra.core.keys.v1.FullViewingKey
 */
export class FullViewingKey extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.FullViewingKey";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new FullViewingKey().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FullViewingKey().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FullViewingKey().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FullViewingKey, a, b);
    }
}
/**
 * @generated from message penumbra.core.keys.v1.WalletId
 */
export class WalletId extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.WalletId";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new WalletId().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WalletId().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WalletId().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WalletId, a, b);
    }
}
/**
 * @generated from message penumbra.core.keys.v1.Diversifier
 */
export class Diversifier extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.Diversifier";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new Diversifier().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Diversifier().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Diversifier().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Diversifier, a, b);
    }
}
/**
 * @generated from message penumbra.core.keys.v1.AddressIndex
 */
export class AddressIndex extends Message {
    /**
     * @generated from field: uint32 account = 2;
     */
    account = 0;
    /**
     * @generated from field: bytes randomizer = 3;
     */
    randomizer = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.AddressIndex";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "account", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
        { no: 3, name: "randomizer", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new AddressIndex().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddressIndex().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddressIndex().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddressIndex, a, b);
    }
}
/**
 * A validator's identity key (decaf377-rdsa spendauth verification key).
 *
 * @generated from message penumbra.core.keys.v1.IdentityKey
 */
export class IdentityKey extends Message {
    /**
     * @generated from field: bytes ik = 1;
     */
    ik = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.IdentityKey";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "ik", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new IdentityKey().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IdentityKey().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IdentityKey().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IdentityKey, a, b);
    }
}
/**
 * A validator's governance key (decaf377-rdsa spendauth verification key).
 *
 * @generated from message penumbra.core.keys.v1.GovernanceKey
 */
export class GovernanceKey extends Message {
    /**
     * @generated from field: bytes gk = 1;
     */
    gk = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.GovernanceKey";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "gk", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new GovernanceKey().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernanceKey().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernanceKey().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernanceKey, a, b);
    }
}
/**
 * @generated from message penumbra.core.keys.v1.ConsensusKey
 */
export class ConsensusKey extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.keys.v1.ConsensusKey";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new ConsensusKey().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConsensusKey().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConsensusKey().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConsensusKey, a, b);
    }
}
